import { render, staticRenderFns } from "./wst_izq.vue?vue&type=template&id=33371e92&"
import script from "./wst_izq.vue?vue&type=script&lang=js&"
export * from "./wst_izq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports